import React from 'react';
import { globals } from 'common-ui';

const canWeHelpPluginHeader = () => <span className="aa-SourceHeaderTitle">Can we help</span>;
const canWeHelpPluginItem = ({ item }: any) => (
  <a href={item.url as string} target="_blank" rel="noopener noreferrer">
    {item.label as string}
  </a>
);

export function createCanWeHelpPlugin() {
  return {
    getSources({ query, state }: { query: string; state: any }) {
      // Case 1: Show when query is empty (initial focus or cleared search)
      const isEmptyQuery = !query;

      // Case 2: Show when search returned no results
      const hasNoResults = state?.context?.noResultsFound === true;

      // Case 3: Show when we're in initial state (just focused)
      const isInitialState = !state?.context?.hasOwnProperty('noResultsFound');

      // Only show plugin if ANY of the conditions are true
      if (!(isEmptyQuery || hasNoResults || isInitialState)) {
        return [];
      }

      return [
        {
          sourceId: 'canWeHelpPlugin',
          getItems() {
            return [
              {
                label: globals.country === 'au' ? 'Offers' : 'Inspire Me',
                url: globals.country === 'au' ? '/latestoffer' : '/jsp/contenthub/uk/home.jsp',
              },
              { label: 'Help & FAQs', url: '/customer-services' },
            ];
          },
          templates: {
            header: canWeHelpPluginHeader,
            item: canWeHelpPluginItem,
          },
        },
      ];
    },
  };
}
